module.exports = __webpack_public_path__ + "e0106718/img/note-list-icon.961c1485.svg";